/**
 * @wordpress/data store name for the Harbor library.
 *
 * @package Give\Vendors\LiquidWeb\Harbor
 */
export const STORE_NAME = 'lw/harbor' as const;
